import { jsx as _jsx } from "react/jsx-runtime";
export function Button({ children, variant = 'primary', className = '', ...rest }) {
    const base = 'inline-flex items-center justify-center rounded-[var(--bp-radius)] px-4 py-2 font-[var(--bp-font-body)] text-sm font-semibold transition active:scale-[0.98] disabled:opacity-50';
    const variants = {
        primary: 'bg-[var(--bp-accent)] text-[var(--bp-bg)]',
        ghost: 'bg-transparent text-[var(--bp-text)] border border-[var(--bp-surface-2)]',
        danger: 'bg-[var(--bp-danger)] text-white',
    };
    return (_jsx("button", { className: `${base} ${variants[variant]} ${className}`, type: "button", ...rest, children: children }));
}
//# sourceMappingURL=button.js.map